<template>
    <div>
        <evenement-commentaire v-for="(commentaire, index) in evenement.commentaires"
                               :key="'commentaire_' + commentaire.id"
                               :commentaire="commentaire" :class="{'mt-5' : index !== 0}"
                               @delete="$emit('updateCommentaires')"/>
        <p v-if="!evenement.commentaires.length">Aucun commentaire pour l'instant</p>
        <div v-if="isUser()">
            <b-col cols="10" offset="1">
                <hr/>
            </b-col>
            <evenement-commentaire-editor :evenement="evenement" @publication="$emit('updateCommentaires')"/>
        </div>
    </div>
</template>

<script>
    const EvenementCommentaireEditor = () => import('@/components/evenement/EvenementCommentaireEditor');
    const EvenementCommentaire       = () => import('@/components/evenement/EvenementCommentaire');

    import {isUser}    from '@/util/auth';

    export default {
        name: "EvenementCommentaires",
        components: {EvenementCommentaire, EvenementCommentaireEditor},
        props: {
            evenement: {
                type: Object,
                required: true
            }
        },
        methods: {isUser}
    }
</script>
